// Waveform: Spitzenwerte werden einmal pro Audiodatei berechnet (zwei Auflösungen)
// und danach nur noch gezeichnet. So bleibt die Timeline auch bei langen Dateien flüssig.

const FINE = 256, COARSE = FINE * 32;

interface Peaks { fine: Float32Array; coarse: Float32Array; sr: number }
const cache = new WeakMap<AudioBuffer, Peaks>();

/** Spitzenwerte (Betrag, über alle Kanäle) je Block berechnen und merken */
export function peaks(buf: AudioBuffer): Peaks {
  let p = cache.get(buf);
  if (p) return p;
  const n = Math.ceil(buf.length / FINE);
  const fine = new Float32Array(n);
  for (let ch = 0; ch < buf.numberOfChannels; ch++) {
    const d = buf.getChannelData(ch);
    for (let b = 0; b < n; b++) {
      let pk = fine[b];
      const end = Math.min(d.length, (b + 1) * FINE);
      for (let k = b * FINE; k < end; k++) { const v = d[k] < 0 ? -d[k] : d[k]; if (v > pk) pk = v; }
      fine[b] = pk;
    }
  }
  const coarse = new Float32Array(Math.ceil(n / 32));
  for (let b = 0; b < n; b++) { const c = b >> 5; if (fine[b] > coarse[c]) coarse[c] = fine[b]; }
  p = { fine, coarse, sr: buf.sampleRate };
  cache.set(buf, p);
  return p;
}

/**
 * Waveform in ein Rechteck zeichnen.
 * offset/dur in Sekunden der Quelle, x/w in Pixeln, mid = Mittellinie, half = halbe Höhe.
 * Füllfarbe vorher mit g.fillStyle setzen.
 */
export function drawWave(g: CanvasRenderingContext2D, buf: AudioBuffer, offset: number, dur: number, x: number, w: number, mid: number, half: number, clipX0 = -Infinity, clipX1 = Infinity) {
  const p = peaks(buf);
  const finePerPx = (dur * p.sr / FINE) / w;
  const useCoarse = finePerPx > 64;
  const arr = useCoarse ? p.coarse : p.fine;
  const per = useCoarse ? finePerPx / 32 : finePerPx;
  const b0 = offset * p.sr / (useCoarse ? COARSE : FINE);
  const from = Math.max(0, Math.floor(clipX0 - x)), to = Math.min(Math.ceil(w), Math.ceil(clipX1 - x));
  for (let px = from; px < to; px++) {
    const s = Math.floor(b0 + px * per), e = Math.max(s + 1, Math.floor(b0 + (px + 1) * per));
    if (s >= arr.length) break;
    let pk = 0;
    for (let k = Math.max(0, s); k < e && k < arr.length; k++) if (arr[k] > pk) pk = arr[k];
    const a = Math.max(0.5, Math.min(1, pk) * half);
    g.fillRect(x + px, mid - a, 1, a * 2);
  }
}
